import { FormattedMessage } from 'react-intl'
import { faChartLine } from '@fortawesome/pro-solid-svg-icons'

import { Card, CardBody, CardHeader } from 'Components/_theme'

import { OrdersReportCardChart } from '../OrdersReportCardChart/OrdersReportCardChart'
import {
  organisationDashboardMockOrderCountData,
  organisationDashboardMockOrderCountLabels,
} from '../OrganisationDashboardDefault/OrganisationDashboardDefault.mocks'

export const DashboardOrdersReportCard = () => (
  <Card className="DashboardOrdersReportCard">
    <CardHeader
      icon={faChartLine}
      subtitle="Lorem ipsum dolor sit amet, consectetur"
    >
      <FormattedMessage id="DashboardOrdersReportCard_open_orders_report" />
    </CardHeader>

    <CardBody>
      <OrdersReportCardChart
        data={organisationDashboardMockOrderCountData}
        labels={organisationDashboardMockOrderCountLabels}
      />
    </CardBody>
  </Card>
)
